import paths from '../paths';
import { ProfileKisaanClient } from './profileKisanClient';

interface IAllVideoPayload {
  userId?: string;
  offset?: number;
  count?: number;
}

export const getAllVideoList = async (payload: IAllVideoPayload) => {
  try {
    const response = await ProfileKisaanClient.get(paths.getVideoListAllProfile(payload));
    return response.data;
  } catch (e) {
    throw e;
  }
};
